<template>
    <div class="page-layout blank mb-10" style="overflow: auto;margin-left: 0px;margin-right: 0px !important;">
        <div class="mb-3 scroll-new br-5">
            <div class="d-flex align-items-center justify-content-center" style="height: 100vh !important;" v-if="ajaxCallInProgress">
                <!-- <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" style="left:170px" class="text-center w-100"/> -->
                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
            </div>
            <div v-else-if="allArchieveTickets.length == 0 && !ajaxCallInProgress" class="text-center mt-10" style="height: 100vh !important;">
                <span class="fw-500 pl-7 pt-10" style="text-align: center !important;">No Tickets Found!</span>
            </div>
            <div v-else v-for="(ticket, list_index) in allArchieveTickets" :key="list_index">
                <div class="list-box px-4 py-2 pointer" :class="{'list-light': list_index % 2, 'highlight' :list_id_index == list_index}" @click="ticketDetails(ticket, list_index)">
                    <div class="d-flex flex-wrap justify-content-between">
                        <span class="fs-14 font-weight-bold text-black">Ticket ID: {{"#" +ticket.ticket_number}}</span>
                        <span class="text-black fw-500 hide-line">{{ticket.created_date}}</span>
                    </div>
                    <div class="pt-1 d-flex align-items-center justify-content-between">
                        <span class="fs-14 fw-600 text-black mr-2" :title="ticket.subject" style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Subject: {{ticket.subject}}</span>
                        <button class="btn btn-archive-status btn-smm">Archived</button>
                    </div>
                    <div class="d-flex  justify-content-between pt-1">
                        <span class="text-black fw-500" :title="ticket.assigned_to" style="max-width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Assigned To: {{ticket.assigned_to || '-'}}</span>
                        <span class="text-black fw-500 hide-line" :title="ticket.created_by" style="max-width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Creator:  {{ticket.created_by || '-'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import {SweetModal} from 'sweet-modal-vue'
import { EventBus } from '../eventBus/nav-bar-event.js';
import archieve from '../mixins/archieve.js';
export default {
    props: ["allArchieveTickets", "list_id_index", "ajaxCallInProgress"],
    components:{
        SweetModal,
        Swal
    },
    mixins:[archieve],
    data(){
        return{
            passed_key: {
                key: 'created_date',
                value: -1
            },
            search_key:'',
            search_key:'',
            count:0,
            success_msg:'',
            warning_msg:'',
            selectedTicket:null,
            status:[],
            ticket_id:'',
            ticketStatus:'',
            showChange:false,
            closed_ticket:{},
            pageLimit: [],
        }
    },
    methods:{
        changeStatus(ticket){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to reopen" + ' ' + JSON.stringify(ticket.ticket_number) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.value) {
                    let params = {
                        ticket_id:ticket.ticket_id
                    }
                    this.confirmReopen(params)
                }
            })
        },
        async confirmReopen(params){
            try {
                let res = await this.reopenTicket(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    // this.getTableData()
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        setPasskey: async function (newKey) {
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
            // this.getTableData();
        },
        ticketDetails(ticket, index){
            let details = {
                index: index,
                ticket: ticket
            }
            this.$emit('viewArchiveTickets', details)
            let temp = []
            if(localStorage.getItem('listData')){
                temp = JSON.parse(localStorage.getItem('listData'))
                temp.unshift(ticket)
                temp = temp.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.ticket_number === value.ticket_number
                    ))
                )
                if(temp.length > 5){
                    temp.splice(temp.length - 1, 1)
                }
                localStorage.setItem('listData', JSON.stringify(temp));
            } else {
                temp.unshift(ticket)
                localStorage.setItem('listData', JSON.stringify(temp));
            }
            this.$emit('updateTabsForList')
        }
    },
    async mounted(){
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
    }
}
</script>
<style scoped>
.btn-archieve{
    background: #002262 !important;
}
.table-new-template tbody tr td{
    width: 10% !important;
}
.overflow-visible{
    overflow: scroll !important
}
.ht-100px{
    height: 100px;
}
.w-200px{
    width: 200px !important
}
span.caps::first-letter{
    text-transform: uppercase !important;
}
@media (max-width: 1100px) {
    .hide-line{
        display: none;
    }
}
</style>